class ProductAddToCart extends HTMLElement {
  connectedCallback() {
    if (this.initialised) return;
    this.initialised = true;

    this.price = this.querySelector('[data-atc-price]');
    this.priceWrapper = this.querySelector('[data-atc-price-wrapper]');
    this.compare = this.querySelector('[data-atc-compare]');
    this.button = this.querySelector('button[name="add"]');
    this.label = this.querySelector('[data-atc-label]');
    this.variantInput = this.querySelector('[data-atc-variant-input]');
    this.addLabel = this.dataset.addLabel || this.label?.textContent.trim();

    this.addEventListener('product-kit:change', () => this.render());

    try {
      this.variants = JSON.parse(this.dataset.variants || '{}');
    } catch {
      this.variants = {};
    }

    this.picker = document.querySelector('variant-radios');
    this.onVariantChange = this.onVariantChange.bind(this);
    this.picker?.addEventListener('change', this.onVariantChange);

    this.render();
  }

  disconnectedCallback() {
    this.picker?.removeEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    const key = Array.from(this.picker.querySelectorAll('fieldset'))
      .map((fieldset) => fieldset.querySelector('input:checked')?.value)
      .join(' / ');

    const variant = this.variants[key];
    if (!variant) return;

    this.dataset.price = variant.price;
    this.dataset.comparePrice = variant.comparePrice;
    if (this.variantInput) this.variantInput.value = variant.id;

    if (this.button) this.button.disabled = !variant.available;
    if (this.label) this.label.textContent = variant.available ? this.addLabel : window.variantStrings.soldOut;

    this.render();
  }

  get kit() {
    return this.querySelector('product-kit');
  }

  render() {
    let total = Number(this.dataset.price) || 0;
    let compareTotal = Number(this.dataset.comparePrice) || 0;

    if (this.kit?.hasSelection) {
      compareTotal = (compareTotal || total) + this.kit.compareTotal;
      total += this.kit.total;
    }

    if (this.price) this.price.innerHTML = total > 0 ? window.formatMoney(total) : '';

    if (this.priceWrapper) this.priceWrapper.hidden = total <= 0;

    if (this.compare) {
      const showCompare = compareTotal > total;
      this.compare.innerHTML = showCompare ? window.formatMoney(compareTotal) : '';
      this.compare.hidden = !showCompare;
    }
  }
}

customElements.get('product-add-to-cart') || customElements.define('product-add-to-cart', ProductAddToCart);
